<table style="text-align:center; margin:auto; overflow:hidden;">
	<tr><td><img src="assets/images/institution/ReportSample.png" style="width:100%; height:auto" /></td></tr>
	<tr>
		<td>
			<div class="row">
				<div class="col-sm-6 col-12" style="padding:10px 0px;">
					<button class="btn btn-outline-info" (click)="subscribe()" style="width:200px;">Subscribe to Activity Report</button>
				</div>
				<div class="col-sm-6 col-12" style="padding:10px 0px;">
					<button class="btn btn-info" (click)="cancel()" style="width:200px;">No, Thank You</button>
				</div>
			</div>
		</td>
	</tr>
</table>
